import { render, staticRenderFns } from "./DeviceOwnership.vue?vue&type=template&id=9dca8b82&"
import script from "./DeviceOwnership.vue?vue&type=script&lang=js&"
export * from "./DeviceOwnership.vue?vue&type=script&lang=js&"
import style0 from "./DeviceOwnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports